/* eslint-disable react/no-unstable-nested-components */
import { FatSelectItem, Select, SelectContent, SelectTrigger, SelectValue } from "components/ui/Select";
import Twemoji from "components/ui/Twemoji";
import classNames from "components/ui/classNames";
import useTheme from "components/ui/useTheme";
import { FormattedDisplayName } from "react-intl";

export const AVAILABLE_CURRENCIES = [
  { currency: "USD", emoji: "🇺🇸" },
  { currency: "BRL", emoji: "🇧🇷" },
  { currency: "EUR", emoji: "🇪🇺" },
  { currency: "GBP", emoji: "🇬🇧" },
  { currency: "JPY", emoji: "🇯🇵" },
  { currency: "AUD", emoji: "🇦🇺" },
  { currency: "CAD", emoji: "🇨🇦" },
];

export const AVAILABLE_CURRENCY_CODES = AVAILABLE_CURRENCIES.map(({ currency }) => currency);

interface SelectFinancialsCurrencyProps {
  disabled?: boolean;
  value: string;
  onChange?: (value: string) => void;
}
export default function SelectFinancialsCurrency({ value, onChange, disabled = false }: SelectFinancialsCurrencyProps) {
  const requestedCurrencyEmoji = AVAILABLE_CURRENCIES.find(({ currency }) => currency === value)?.emoji;
  const theme = useTheme();

  return (
    <Select disabled={disabled} defaultValue={value} onValueChange={(value) => onChange?.(value)}>
      <SelectTrigger
        className={classNames(
          "inline-flex",
          "w-full border border-slate-200 bg-white sm:max-w-28",
          "font-aeonik text-sm font-medium tracking-wide text-slate-600",
          "hover:ring-2 focus-visible:ring-2",
          "hover:ring-offset-1 focus-visible:ring-offset-1",
          "hover:border-transparent hover:ring-slate-100 hover:ring-offset-slate-300",
          "focus-visible:border-transparent focus-visible:ring-indigo-100 focus-visible:ring-offset-indigo-300",
          "disabled:select-none",
          "truncate",
          "dark:border-slate-950 dark:bg-slate-700 dark:text-slate-300",
          "dark:hover:ring-slate-900 dark:hover:ring-offset-slate-900",
          "dark:focus-visible:ring-slate-900 dark:focus-visible:ring-offset-slate-900",
        )}
      >
        <SelectValue>
          <div className="inline-flex items-center space-x-1">
            <span>{value}</span>
            {requestedCurrencyEmoji && <Twemoji emoji={requestedCurrencyEmoji} />}
          </div>
        </SelectValue>
      </SelectTrigger>

      <SelectContent
        className={classNames("min-w-56 rounded-lg border border-slate-300 text-sm", {
          "border-slate-900/80 bg-slate-900 text-slate-300 shadow-neutral-950/40": theme === "dark",
          dark: theme === "dark",
        })}
        side="top"
      >
        {AVAILABLE_CURRENCIES.map(({ currency, emoji }) => {
          return (
            <FatSelectItem key={currency} className="cursor-pointer rounded-lg text-sm" value={currency}>
              <h4 className="text-xs font-bold text-slate-600 dark:text-slate-300">{currency}</h4>
              <div className="flex items-center space-x-2">
                <p className="text-xs text-slate-500">
                  <FormattedDisplayName type="currency" value={currency} />
                </p>
                <Twemoji emoji={emoji} />
              </div>
            </FatSelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
